<template>
  <CButtonGroup>
    <CButton
      :class="getGroupButtonColor(graphViewType.weekly)"
      @click="setGroupButtonColor('weekly')"
    >Weekly</CButton>
    <CButton
      :class="getGroupButtonColor(graphViewType.monthly)"
      @click="setGroupButtonColor('monthly')"
    >Monthly</CButton>
    <CButton
      :class="getGroupButtonColor(graphViewType.yearly)"
      @click="setGroupButtonColor('yearly')"
    >Yearly</CButton>
  </CButtonGroup>
</template>

<script>
export default {
  name: "graphViewTypeComponent",
  data() {
    return {
      graphViewType: { weekly: false, monthly: true, yearly: false }
    };
  },
  methods: {
    getGroupButtonColor(status) {
      switch (status) {
        case true:
          return "button-group-active";
        case false:
          return "button-group";
      }
    },
    setGroupButtonColor(state) {
      switch (state) {
        case "weekly":
          this.graphViewType = { weekly: true, monthly: false, yearly: false };
          break;
        case "monthly":
          this.graphViewType = { weekly: false, monthly: true, yearly: false };
          break;
        case "yearly":
          this.graphViewType = { weekly: false, monthly: false, yearly: true };
          break;
      }
    }
  }
};
</script>

<style>

</style>